// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class FilesDownloadService {
  private sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  private contextValue: any = {};
  private files: Array<any> = [];

  public getFilesByContextAndProcess<T>(params): Observable<T> {
    const url = this.Global.services.files.draft();
    return this.sendService.get(url, { params });
  }

  public assignUri(params): Observable<any> {
    const url = this.Global.services.files.psurl();
    return this.sendService.get(url, { params });
  }

  set setcontext(context: any) {
    this.contextValue = context;
  }
  get getcontext() {
    return this.contextValue;
  }

  set setFiles(files: Array<any>) {
    this.files = files;
  }
  get getFiles(): Array<any> {
    return this.files;
  }
}
